module.exports = __webpack_public_path__ + "img/t-23575-014.66eeaaf1.jpg";